var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mw-100"},_vm._l((_vm.fields),function(field,index){return _c('span',{key:index},[_c('number-flip',{attrs:{"value":_vm.getValue(field, _vm.value),"color":_vm.color,"width":_vm.width}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }